module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "epigraphPage",
    attrs: {
      "id": "epi01"
    }
  }, [_c('div', {
    staticClass: "epigraph"
  }, [_c('p', {
    staticClass: "epigraphText1"
  }, [_vm._v("“Then the bird doesn’t belong to any of you?” Spade asked.")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphText"
  }, [_vm._v("“Belong?” the fat man said jovially. “Well, sir, you might say it belonged to the King of Spain, but…an article of that value that has passed from hand to hand…is clearly the property of whoever can get a hold of it.”")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphSource"
  }, [_vm._v("Dashiell Hammett, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Maltese Falcon")])])]), _vm._v(" "), _c('div', {
    staticClass: "epigraph"
  }, [_c('p', {
    staticClass: "epigraphText"
  }, [_vm._v("Every man is as Heaven made him, and sometimes a great deal worse.")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphSource"
  }, [_vm._v("Cervantes, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Don Quixote")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "pagex"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "pagex"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28bf054e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780310563105_epi01.vue
// module id = 78
// module chunks = 0